/**
 * A planner working inside a client's wedding (2026-09-18).
 *
 * Kept per browser tab (sessionStorage), so a planner can have two client
 * weddings open side by side and a closed tab never leaves them "inside"
 * someone's wedding next time. The server checks the assignment on every
 * request — this only says which wedding the tab is asking about.
 */
const KEY = 'vowsera-acting-wedding';

export const ACTING_HEADER = 'X-VowsEra-Wedding';

// Screens that work inside a client's wedding. Everything else in the couple
// dashboard (billing, account settings, personal pages) stays the couple's.
export const ACTING_PATHS = [
  '/dashboard',
  '/dashboard/my-wedding',
  '/dashboard/checklist',
  '/dashboard/budget',
  '/dashboard/events',
  '/dashboard/wedding-timeline',
  '/dashboard/guests',
  '/dashboard/rituals',
  '/dashboard/baraat-vidaai',
  '/dashboard/wedding-week',
  '/dashboard/arrivals',
  '/dashboard/accommodations',
  '/dashboard/seating-chart',
  '/dashboard/bookings',
  '/dashboard/gifts-received',
  '/dashboard/emergency-contacts',
  '/dashboard/guest-messages',
  '/dashboard/hospitality-desk',
];

export const isActingPath = (pathname) => ACTING_PATHS.includes(String(pathname || '').replace(/\/+$/, '') || '/');

export const getActingWedding = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed?.id ? parsed : null;
  } catch {
    return null;
  }
};

export const startActing = ({ id, label }) => {
  try { sessionStorage.setItem(KEY, JSON.stringify({ id, label: label || 'Client wedding' })); } catch { /* storage blocked */ }
};

export const stopActing = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* storage blocked */ }
};
